import * as React from "react";
import { useState } from "react";
import { useAppSelector } from "../hooks/storeHooks";
import Header from "./Header";
import TextInsertion from "./TextInsertion";
import StoreSelector from "./StoreSelector";
import StoreModal from "./StoreModal";

interface AppProps {
  title: string;
}

const App: React.FC<AppProps> = (props: AppProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const accounts = useAppSelector((state) => state.accounts.accounts);
  const activeAccountId = useAppSelector((state) => state.accounts.activeAccountId);
  const hasActiveAccount = Boolean(accounts.find(a => a.id === activeAccountId));

  console.log(`Running ${props.title} taskpane.`);

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <Header logo="assets/logo-filled.png" title={props.title} message="Welcome" />
      <main className="mx-auto w-full max-w-3xl space-y-6 px-4 py-8">
        {!hasActiveAccount && (
          <div className="rounded-lg bg-indigo-50 p-6 shadow-sm ring-1 ring-indigo-200">
            <h2 className="mb-2 text-lg font-semibold text-indigo-900">Welcome to the Magento Connector for Excel</h2>
            <p className="text-sm text-indigo-800">
              Connect your Magento store to effortlessly sync your product catalog directly into Excel. Bulk update prices, manage inventory, and push your changes back to Magento with a single click. Add your store connection below to get started!
            </p>
            <p className="mt-3 text-xs text-indigo-700">
              Don't have a Magento store?{" "}
              <a
                href="https://business.adobe.com/request-consultation.html?mktfrm_poi=commerce"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium underline hover:text-indigo-950"
              >
                Learn more or sign up for Adobe Commerce (Magento)
              </a>.
            </p>
          </div>
        )}
        <StoreSelector onOpenModal={() => setIsModalOpen(true)} />
        <TextInsertion />
      </main>
      <StoreModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default App;
